import { render, staticRenderFns } from "./edit-miothreshold.vue?vue&type=template&id=f8ec3732&"
import script from "./edit-miothreshold.vue?vue&type=script&lang=ts&"
export * from "./edit-miothreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports